<template>
  <div class="admin_home">
    <div class="top">
      <p>欢迎您登录 {{ websiteName }}</p>
      <!-- examState -1：审核不通过 0：待审核 100：审核通过 -->
      <p>
        {{ userData.greeting }} {{ userData.username }}
        <el-tag type="danger" v-if="userData.examState === -1"
          >审核不通过</el-tag
        >
        <el-tag v-else-if="userData.examState === 0">待审核</el-tag>
      </p>
    </div>
    <div class="top-number" style="margin-top: 10px">
      <ul class="list-number">
        <li class="item-number green-back">
          <div class="item-content">
            <div class="item-ritext">
              <p>注册企业单位数量</p>
              <p class="green">10</p>
            </div>
            <div class="item-imglf">
              <img src="../../assets/images/danwei_zc_icon@2x.png" />
            </div>
          </div>
        </li>
        <li class="item-number bluer-back">
          <div class="item-content">
            <div class="item-ritext">
              <p>本月注册企业单位数量</p>
              <p class="blue">3</p>
            </div>
            <div class="item-imglf">
              <img src="../../assets/images/danwei_sl_icon@2x.png" />
            </div>
          </div>
        </li>
        <li class="item-number orger-back">
          <div class="item-content">
            <div class="item-ritext">
              <p>注册企业单位覆盖省市</p>
              <p class="orger">5</p>
            </div>
            <div class="item-imglf">
              <img src="../../assets/images/fugai.png" />
            </div>
          </div>
        </li>
        <li class="item-number red-back">
          <div class="item-content">
            <div class="item-ritext">
              <p>注册企业单位行业</p>
              <p class="red">6</p>
            </div>
            <div class="item-imglf">
              <img src="../../assets/images/danwei_hy.png" />
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="main">
      <div class="title">快捷操作</div>
      <el-scrollbar class="scroll">
        <ul class="list">
          <li class="item">
            <div class="item_head">
              <span>账户信息</span>
              <span @click="goPage('/admin/account-manage')"
                >更多<i class="el-icon-arrow-right"></i
              ></span>
            </div>
            <ul class="item_body">
              <li>
                <label>姓名：</label>
                <span>{{ userData.unit.linkman }}</span>
              </li>
              <li>
                <label>手机号：</label>
                <span>{{ userData.unit.linkphone }}</span>
              </li>
              <li>
                <label>机构全称：</label>
                <span>{{ userData.unit.unitName }}</span>
              </li>
            </ul>
          </li>
          <li class="item">
            <div class="item_head">
              <span>节点管理</span>
              <span @click="goPage('/admin/node-manage')"
                >更多<i class="el-icon-arrow-right"></i
              ></span>
            </div>
            <ul class="item_body">
              <li>
                <label>节点编码：</label>
                <span>{{ userData.node.nodeIdcode }}</span>
              </li>
              <li>
                <label>节点名称：</label>
                <span>{{ userData.node.nodeName }}</span>
              </li>
              <li>
                <label>节点类型：</label>
                <span>{{
                  userData.node.nodeType == 0 ? "省级节点" : "市级节点"
                }}</span>
              </li>
            </ul>
          </li>
          <li class="item">
            <div class="item_head">
              <span>技术支撑</span>
              <!-- <span @click="goPage('/admin/node-manage')">更多<i class="el-icon-arrow-right"></i></span> -->
            </div>
            <ul class="item_body">
              <li>
                <label>客服电话：</label>
                <span>010-84911329 / 010-84911334</span>
              </li>
              <li style="white-space: nowrap">
                <label>电子邮箱：</label>
                <span>tech@chinasafety.ac.cn</span>
              </li>
              <li>
                <label>联系地址：</label>
                <span>北京市朝阳区北苑路32号院甲1号楼安全大厦</span>
              </li>
            </ul>
          </li>
        </ul>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { homeInfo, websiteInfo } from "@/api/admin";
export default {
  name: "AdminHome",
  data() {
    return {
      userData: {
        unit: {},
        node: {},
      },
      websiteName: "",
    };
  },
  // computed:{
  //     ...mapState({
  //         userInfo(state){
  //             state = state.user.userInfo
  //             return state
  //         },
  //         unitInfo(state){
  //             state = state.user.unitInfo
  //             return state
  //         },
  //     })
  // },
  mounted() {
    // console.log(JSON.parse(JSON.stringify(this.userInfo)))
    // console.log(JSON.parse(JSON.stringify(this.unitInfo)))
    // console.log(JSON.parse(JSON.stringify(this.$store.state.user.userInfo)))
    // console.log(JSON.parse(JSON.stringify(this.$store.state.user.unitInfo)))
    this.homeInfo();
    this.getWebsite();
  },
  methods: {
    homeInfo() {
      //我的主页
      homeInfo({}).then((res) => {
        console.log(res, "我的主页");
        // console.log(JSON.parse(JSON.stringify(res.data.userInfo)))
        this.userData = res.data.userInfo || {};
      });
    },
    getWebsite() {
      //获取站点设置
      websiteInfo({}).then((res) => {
        this.websiteName = res.data.siteName;
      });
    },
    goPage(url) {
      //跳转
      this.$router.push({
        path: url,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.admin_home {
  // border: 1px solid #0f0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .top {
    background: url("~@/assets/images/admin/houtai_shouy_img.png") no-repeat
      center/100% 100%;
    height: 153px;
    flex: none;
    border-radius: 10px;
    padding-top: 45px;
    padding-left: 85px;
    box-sizing: border-box;
    p:nth-child(1) {
      color: #333;
      font-size: 16px;
      font-weight: 400;
    }
    p:nth-child(2) {
      font-weight: 600;
      color: #00aa73;
      font-size: 26px;
      margin-top: 15px;
    }
  }
  .top-number {
    width: 100%;
    height: 153px;
    flex: none;
    border-radius: 10px;
    padding-top: 45px;
    padding-left: 30px;
    box-sizing: border-box;
    background-color: #fff;
    // overflow: auto hidden;

    // 操作数据量
    .list-number {
      min-width: 1200px;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      box-sizing: border-box;

      .item-number {
        box-sizing: border-box;
        // width: 219px;
        padding: 19px 20px 13px 20px;
        margin-right: 22px;
        .item-content {
          display: flex;
          flex-direction: row;
          align-items: center;
          .item-ritext {
            display: flex;
            flex-direction: column;
            padding-right: 43px;
            p:nth-child(1) {
              font-size: 14px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 600;
              color: #333333;
            }
            p:nth-child(2) {
              font-weight: 600;
              font-size: 20px;
              font-family: PingFangSC-Medium, PingFang SC;
            }
          }
          .item-imglf {
            width: 37px;
            height: 37px;
            img {
              width: 100%;
              height: 100%;
              object-fit: scale-down;
            }
          }
        }
        .green {
          color: #00aa73;
        }
        .blue {
          color: #0053aa;
        }
        .orger {
          color: #e57200;
        }
        .red {
          color: #f40000;
        }
      }
      .green-back {
        background: linear-gradient(135deg, #ffffff 0%, #c5ffec 100%);
        border: 1px solid #a7e1ce;
      }
      .bluer-back {
        background: linear-gradient(135deg, #ffffff 0%, #c5e5ff 100%);
        border: 1px solid #a7b3e1;
      }
      .orger-back {
        background: linear-gradient(135deg, #ffffff 0%, #ffddc5 100%);
        border: 1px solid #fdc3a1;
      }
      .red-back {
        background: linear-gradient(135deg, #ffffff 0%, #ffc5c5 100%);
        border: 1px solid #faabab;
      }
    }
  }
  .main {
    background-color: #fff;
    border-radius: 10px;
    flex: 1;
    margin-top: 20px;
    padding: 35px 30px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    width: 100%;

    .title {
      font-size: 20px;
      font-weight: 600;
      color: #333;
      flex: none;
    }
    .scroll {
      flex: 1;
      margin-top: 25px;
       min-width: 1200px;
       ::v-deep {
      .el-scrollbar__wrap {
        overflow-x: hidden;
      }
    }
      .list {
        // border:1px solid #0f0;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        padding: 8px;
        box-sizing: border-box;
        .item {
          // width: 300px;
          min-width: 270px;
          max-width: 417px;
          // height: 220px;
          background: #fff;
          box-shadow: 0px 0px 8px 0px rgba(172, 172, 172, 0.5);
          padding: 30px 35px 35px;
          box-sizing: border-box;
          margin-right: 15px;
          margin-bottom: 30px;
          border-radius: 10px;
          .item_head {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 25px;
            border-bottom: 2px solid #f2f2f2;
            span:nth-child(1) {
              font-weight: 700;
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 600;
              color: #343434;
            }
            span:nth-child(2) {
              font-weight: 400;
              color: #666666;
              font-size: 14px;
              cursor: pointer;
              i {
                font-weight: 700;
              }
            }
            .blue {
              color: #1251cf;
            }
            .orange {
              color: #fe831f;
            }
          }
          .item_body {
            // border: 1px solid #0f0;
            li {
              font-weight: 400;
              color: #666;
              // border: 1px solid #f00;
              margin-top: 25px;
              label {
              }
              span {
              }
            }
          }
        }
      }
    }
  }
}
</style>
